import React from 'react';
import { View } from 'react-native';
import { createStyleSheet } from '../../utils';
import { useStyleSheet } from '../../hooks';
import { Checkbox } from '../Checkbox';
import { Text } from '../Text';
export const Selector = ({ onChange, value, numOfSelectedItems = 0, children, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(View, { style: styles.left },
            React.createElement(Checkbox, { checked: value, onChange: onChange, style: styles.checkbox }),
            React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold' }, numOfSelectedItems),
            React.createElement(Text, { style: styles.description, type: 'body', size: 'lg', weight: 'regular' }, "Selected")),
        React.createElement(View, { style: styles.right }, children)));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        padding: size.G,
        borderWidth: 1,
        borderColor: color.invert2.p4,
        borderRadius: size.G,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
    },
    left: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
    right: {
        marginLeft: size.G
    },
    checkbox: {
        marginRight: size.G
    },
    description: {
        color: color.invert2.p56,
        marginLeft: size.B
    }
}));
//# sourceMappingURL=index.js.map